export default {
  wallets: [],
  walletsCount: 0
}
